import { Icon } from '../../components/Icon.tsx';
import { PRIORITY_LABEL, type IssuePriority } from './types.ts';

/** Urgent is flagged in red with an icon; Low and Normal are quiet text only. */
export function PriorityMark({ priority }: { priority: IssuePriority }): JSX.Element {
  if (priority === 'URGENT') {
    return (
      <span className="inline-flex items-center text-xs font-medium text-destructive">
        <Icon name="priority_high" size={16} />
        {PRIORITY_LABEL.URGENT}
      </span>
    );
  }
  return <span className="text-xs text-muted-foreground">{PRIORITY_LABEL[priority]}</span>;
}
